export default __webpack_public_path__ + "static/media/rani-img.c558959e.png";